import React, { FC, useState } from 'react';
import { useCurrencies } from '../../hooks/useCurrencies';
import { currency } from '../../utils/currency';

interface PropertyPriceProps {
  price: number;
}

const PropertyPrice: FC<PropertyPriceProps> = ({ price }) => {
  const { current } = useCurrencies();

  const displayPrice = current?.rate ? price * current?.rate : price;
  return <>{currency(displayPrice, current?.code)}</>;
};

export default PropertyPrice;
